import config from "appConfig";

const walls = {
  "1-2-3-4-5": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-3-4-5.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-3-4-5.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-6.svg`,
  },
  "1-2-3-4-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-3-4-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-3-4-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-7.svg`,
  },
  "1-2-3-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-3-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-3-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-8.svg`,
  },
  "1-2-4-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-4-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-4-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-6.svg`,
  },
  "1-3-4-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-3-4-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-3-4-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-7.svg`,
  },
  "2-3-4-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/2-3-4-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-2-3-4-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-8.svg`,
  },
};

export default walls;
